import React, { useState, useEffect } from "react";
import videoFull from '../../video/video2.mov';
import { Header } from "../../header";
import { Footer } from '../../components/footer';

export const ConcertsPage = () => {
  const [concerts, setConcerts] = useState([]);

  const parseWidgetData = (widgetString) => {
    if (!widgetString || widgetString === "") return null;
    const match = widgetString.match(/event=([^&]+)&token=([^&]+)/);
    if (match) {
      return {
        event: match[1],
        token: match[2]
      };
    }
    return null;
  };

const handleBuyClick = (concert) => {
  if (window.ym) {
    window.ym(108748738, 'reachGoal', 'buy_ticket_click', {
      concert: `${concert.date}, ${concert.place}`
    });
  }

  if (concert.widget && concert.widget !== "") {
    const widgetData = parseWidgetData(concert.widget);
    if (widgetData) {
      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

      if (isMobile) {
        window.open(`https://ticketscloud.com/widget/#event=${widgetData.event}&token=${widgetData.token}&lang=ru`, '_blank');
      } else {
        const btn = document.getElementById(`tc-trigger-${widgetData.event}`);
        if (btn) btn.click();
      }
      return;
    }
  }

  if (concert.link) {
    window.open(concert.link, '_blank');
  }
};

  document.title = "Концерты | Сайт Алёны Швец";

  const fetchConcerts = async () => {
    try {
      const response = await fetch("https://api.alyonatestsite.store/api/settings");
      if (!response.ok) {
        throw new Error("Ошибка загрузки данных");
      }
      const data = await response.json();
      setConcerts(data.concerts);
    } catch (err) {
      console.error("Error fetching concerts:", err);
    }
  };

  // Загружаем скрипт только после того, как данные о концертах получены
  useEffect(() => {
    if (concerts.length === 0) return;

    const existing = document.querySelector('script[src*="tcwidget"]');
    if (existing) existing.remove();

    const script = document.createElement('script');
    script.src = 'https://ticketscloud.com/static/scripts/widget/tcwidget.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, [concerts]);

  useEffect(() => {
    fetchConcerts();
  }, []);

  return (
    <section
      id="main"
      className="w-full flex flex-col justify-center items-center bg-black"
    >
      <Header
        page="concerts"
        fixed={false}
        transparent={true}
      />

      <div className="w-full relative overflow-hidden">
        <video
          className="w-full lg:hidden"
          src={videoFull}
          autoPlay
          loop
          muted
          playsInline
        />
        <video
          className="w-full hidden lg:block"
          src={videoFull}
          autoPlay
          loop
          muted
          playsInline
        />
        <div className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-t from-black via-black/80 to-transparent"></div>
      </div>

      <div className="w-full bg-gradient-to-b from-black via-sky-900 to-black p-6 md:p-16">
        <h1 className="font-lack text-white text-3xl lg:text-5xl mb-12 text-center">
          Предстоящие концерты
        </h1>
        <div className="mt-12 grid grid-cols-1 gap-8 place-items-center w-full">
          {concerts.map((concert, index) => {
  const widgetData = parseWidgetData(concert.widget);
  return (
    <div key={index} className="group flex flex-col bg-black/50 rounded-lg cursor-pointer overflow-hidden border-2 border-transparent hover:border-sky-500 transition-all duration-300">
      <img
        src={`https://api.alyonatestsite.store${concert.preview}`}
        alt={concert.name}
        className="w-[1440px] max-h-[500px] object-cover"
      />
      <div className="w-full px-6 py-4 flex flex-col justify-between">
        <div>
          <h3 className="text-xl lg:text-2xl font-lack text-white">{concert.date}</h3>
          <p className="text-base lg:text-lg font-lack text-gray-300">{concert.place}</p>
        </div>

        {/* Одна кнопка для всех устройств — просто <a> с data-атрибутами */}
        {widgetData ? (
          <a
            href={concert.widget}
            data-tc-event={widgetData.event}
            data-tc-token={widgetData.token}
            onClick={() => {
              if (window.ym) {
                window.ym(108748738, 'reachGoal', 'buy_ticket_click', {
                  concert: `${concert.date}, ${concert.place}`
                });
              }
            }}
            className="mt-4 font-lack text-lg rounded-lg px-6 py-2 bg-gradient-to-r from-green-500 to-sky-500 text-white hover:from-green-600 hover:to-sky-600 transition-all duration-300 text-center"
          >
            Купить билет
          </a>
        ) : (
          <button
            onClick={() => {
              if (window.ym) {
                window.ym(108748738, 'reachGoal', 'buy_ticket_click', {
                  concert: `${concert.date}, ${concert.place}`
                });
              }
              if (concert.link) window.open(concert.link, '_blank');
            }}
            className="mt-4 font-lack text-lg rounded-lg px-6 py-2 bg-gradient-to-r from-green-500 to-sky-500 text-white hover:from-green-600 hover:to-sky-600 transition-all duration-300"
          >
            Купить билет
          </button>
        )}
      </div>
    </div>
  );
})}
        </div>
      </div>
      <Footer color="black" />
    </section>
  );
};